import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
//import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IgmsAlertData, GmsAlertComponent } from '../dialogs/gms-alert/gms-alert.component';
// import { IGmsConfirmData, GmsconfirmComponent } from '../dialogs/gmsconfirm/gmsconfirm.component';
@Injectable({
  providedIn: 'root'
})
export class GmsdialogService {
  defaultwidth: string = "310px";
  constructor(private _dialog: MatDialog) {

  }
  showAlert(data: IgmsAlertData, width: string = this.defaultwidth) {
    return this._dialog.open(GmsAlertComponent, {
      data: data,
      disableClose: true,
      width: width
    });
  }

  /*showGmsconfirm(data: IGmsConfirmData, width: string = this.defaultwidth, disableClose: boolean = true, ) {
    return this._dialog.open(GmsconfirmComponent, {
      data: data,
      disableClose: disableClose,
      width: width
    });
  }*/

}
